@let holdsLoaded = holdSelectors.loaded | select:false;
@let hasPatron = patronSelectors.hasPatron | select:false;
@let hasBlocks = patronStatusSelectors.hasBlocks | select:false;
@let firstHold = holdSelectors.singleHold(catalogRecordId) | select:FALLBACK_HOLD;
@let hasAnyHolds = holdSelectors.hasHolds(catalogRecordId) | select:false;
@let iconName = hasAnyHolds ? 'bookmark' : 'bookmark_add';
@let iconColor = hasAnyHolds ? 'text-primary' : 'text-on-surface-variant';
@let hasOnlyOneHold = holdSelectors.hasOneHold(catalogRecordId) | select:false;

@if (visible) {
  @if (hasAnyHolds) {
    <!-- If user has ANY holds on this catalog record -->
    @if (hasOnlyOneHold) {
      <!-- User has only one hold on the record -->
      @let isEditable = holdStatelessSelectors.isEditable(firstHold) | select:false;
      @let cannotEditHoldTooltip = holdStatelessSelectors.cannotEditHoldTooltip(firstHold) | select:'';

      <!-- Filled in icon button, opens the edit hold dialog. -->
      <mx-icon-button [icon]="iconName" [iconClasses]="iconColor" [enabled]="isEditable" (click)="onEditHold(firstHold)"
                      [disabledTooltip]="cannotEditHoldTooltip"/>
    } @else {
      <!-- User has more than one hold on the record, show a filled in icon button that routes them to the hold list. -->
      <mx-icon-button [icon]="iconName" [iconClasses]="iconColor" routeName="HOLDS" tooltip="View Holds"/>
    }
  } @else {
    <!-- If there are currently no holds on this catalog record -->
    <mx-icon-button [icon]="iconName" [iconClasses]="iconColor" [enabled]="!hasBlocks && (!hasPatron || holdsLoaded)" (click)="onPlaceHold()"
                    [disabledTooltip]="hasBlocks ? 'Cannot place hold due to blocks on your account.' : ''" tooltip="Place Hold"/>
  }
} @else {
  <!-- Render a dummy button to forcibly allow space. -->
  <mx-icon-button class="invisible" [enabled]="false"/>
}
